import apiClient from './client'

export interface LikertQuestion {
  id: string
  text: string
}

export interface Survey {
  survey_id: string
  title: string
  description: string | null
  likert_questions: LikertQuestion[]
  free_text_question: string
  closes_at: string
}

export interface SurveyResponseData {
  survey_id: string
  likert_answers: Record<string, number>
  free_text_answer: string
  created_at: string
  updated_at: string
}

export const getActiveSurvey = async (): Promise<Survey> => {
  return apiClient.get<Survey>('/surveys/active')
}

export const getMyResponse = async (surveyId: string): Promise<SurveyResponseData> => {
  return apiClient.get<SurveyResponseData>(`/surveys/${surveyId}/my-response`)
}

export const submitResponse = async (
  surveyId: string,
  data: { likertAnswers: Record<string, number>; freeTextAnswer: string },
): Promise<SurveyResponseData> => {
  return apiClient.post<SurveyResponseData>(`/surveys/${surveyId}/respond`, data)
}
